export const k3000FrontierProducts = [
  {
    id: 1100,
    name: 'BON047',
    category: 'KIA K3000 FRONTIER BONGO98',
    subcategory: '램프',
    price: 0,
    status: '재고있음',
    description: 'HEAD LAMP',
    fullDescription: 'K3000 프론티어 봉고 98 헤드램프입니다. OK60A-51010 L / OK60D-51020 R 규격으로 제작되었습니다.',
    compatibleVehicles: ['K3000', '프론티어', '봉고 98'],
    voltage: '12V',
    partNumber: 'OK60A-51010 L / OK60D-51020 R',
    image: 'https://public.readdy.ai/ai/img_res/931528ad689fbbc54727ff63fd744f32.jpg',
    images: [],
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: '고휘도 조명', description: '야간 시인성 향상' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: 'OK60A-51010 L / OK60D-51020 R' },
      { icon: 'ri-water-flash-line', title: '방수 설계', description: '우천 시 안전' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20headlamp%20quality%20testing%20laboratory%20clean%20environment%20professional%20lighting&width=1200&height=900&seq=bon047craft&orientation=landscape',
      story: 'K3000 프론티어 봉고 98의 안전한 야간 주행을 위한 고품질 헤드램프입니다.',
      details: ['순정 규격 제작', '고휘도 조명', '내구성 강화 렌즈', '방수 처리 완료'],
    },
  },
  {
    id: 1101,
    name: 'BON048',
    category: 'KIA K3000 FRONTIER BONGO98',
    subcategory: '램프',
    price: 0,
    status: '재고있음',
    description: 'CORNER LAMP',
    fullDescription: 'K3000 프론티어 봉고 98 코너램프입니다. OK60C-51-060 L / OK60C-51-070 R 규격으로 제작되었습니다.',
    compatibleVehicles: ['K3000', '프론티어', '봉고 98'],
    voltage: '12V',
    partNumber: 'OK60C-51-060 L / OK60C-51-070 R',
    image: 'https://readdy.ai/api/search-image?query=Kia%20K3000%20Frontier%20Bongo%20truck%20corner%20lamp%20clear%20lens%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting&width=800&height=1000&seq=bon048main&orientation=portrait',
    images: [],
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: '코너 조명', description: '측면 시인성 향상' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: 'OK60C-51-060 L / OK60C-51-070 R' },
      { icon: 'ri-water-flash-line', title: '방수 설계', description: '우천 시 안전' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20corner%20lamp%20manufacturing%20clean%20facility%20professional%20lighting&width=1200&height=900&seq=bon048craft&orientation=landscape',
      story: 'K3000 프론티어 봉고 98의 측면 시인성을 높이는 코너램프입니다.',
      details: ['순정 규격 제작', '내구성 강화', '방수 처리', '완벽한 호환'],
    },
  },
  {
    id: 1102,
    name: 'BON049',
    category: 'KIA K3000 FRONTIER BONGO98',
    subcategory: '램프',
    price: 0,
    status: '재고있음',
    description: 'TAIL LAMP',
    fullDescription: 'K3000 프론티어 봉고 98 테일램프입니다. OK68D-51-030/040 규격으로 제작되었습니다.',
    compatibleVehicles: ['K3000', '프론티어', '봉고 98'],
    voltage: '12V',
    partNumber: 'OK68D-51-030/040',
    image: 'https://readdy.ai/api/search-image?query=Kia%20K3000%20Frontier%20Bongo%20truck%20tail%20lamp%20red%20lens%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting&width=800&height=1000&seq=bon049main&orientation=portrait',
    images: [],
    colors: ['#FF0000'],
    features: [
      { icon: 'ri-lightbulb-line', title: '후방 조명', description: '후방 시인성 향상' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: 'OK68D-51-030/040' },
      { icon: 'ri-water-flash-line', title: '방수 설계', description: '우천 시 안전' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20tail%20lamp%20manufacturing%20clean%20facility%20professional%20lighting&width=1200&height=900&seq=bon049craft&orientation=landscape',
      story: 'K3000 프론티어 봉고 98의 후방 안전을 책임지는 테일램프입니다.',
      details: ['순정 규격 제작', '고휘도 LED', '방수 처리', '내구성 보장'],
    },
  },
  {
    id: 1103,
    name: 'BON050',
    category: 'KIA K3000 FRONTIER BONGO98',
    subcategory: '램프',
    price: 0,
    status: '재고있음',
    description: 'FOG LAMP',
    fullDescription: 'K3000 프론티어 봉고 98 안개등입니다. 악천후 시 시인성을 높여줍니다.',
    compatibleVehicles: ['K3000', '프론티어', '봉고 98'],
    voltage: '12V',
    partNumber: '-',
    image: 'https://readdy.ai/api/search-image?query=Kia%20K3000%20Frontier%20Bongo%20truck%20fog%20lamp%20yellow%20lens%20rectangular%20housing%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting&width=800&height=1000&seq=bon050main&orientation=portrait',
    images: [],
    colors: ['#FFD700'],
    features: [
      { icon: 'ri-lightbulb-line', title: '안개등', description: '악천후 시인성' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환성' },
      { icon: 'ri-water-flash-line', title: '방수 설계', description: '우천 시 안전' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20fog%20lamp%20manufacturing%20clean%20facility%20professional%20lighting&width=1200&height=900&seq=bon050craft&orientation=landscape',
      story: 'K3000 프론티어 봉고 98의 악천후 주행을 돕는 안개등입니다.',
      details: ['순정 규격 제작', '고휘도 조명', '방수 처리', '내구성 보장'],
    },
  },
  {
    id: 1104,
    name: 'BON051',
    category: 'KIA K3000 FRONTIER BONGO98',
    subcategory: '외장',
    price: 0,
    status: '재고있음',
    description: 'GRILLE',
    fullDescription: 'K3000 프론티어 봉고 98 그릴입니다. OK67A-50710E / OK60E-50710B 규격으로 제작되었습니다.',
    compatibleVehicles: ['K3000', '프론티어', '봉고 98'],
    voltage: '-',
    partNumber: 'OK67A-50710E / OK60E-50710B',
    image: 'https://readdy.ai/api/search-image?query=Kia%20K3000%20Frontier%20Bongo%20truck%20front%20grille%20chrome%20plastic%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20lighting&width=800&height=1000&seq=bon051main&orientation=portrait',
    images: [],
    colors: ['#808080'],
    features: [
      { icon: 'ri-shield-check-line', title: '순정 규격', description: 'OK67A-50710E / OK60E-50710B' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
      { icon: 'ri-star-line', title: '고품질', description: '내구성 보장' },
      { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '안심 사용' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20grille%20manufacturing%20clean%20facility%20professional%20lighting&width=1200&height=900&seq=bon051craft&orientation=landscape',
      story: 'K3000 프론티어 봉고 98의 전면부를 보호하는 그릴입니다.',
      details: ['순정 규격 제작', '고품질 소재', '내구성 보장', '완벽한 호환'],
    },
  },
  {
    id: 1105,
    name: 'BON052',
    category: 'KIA K3000 FRONTIER BONGO98',
    subcategory: '외장',
    price: 0,
    status: '재고있음',
    description: 'FENDER',
    fullDescription: 'K3000 프론티어 봉고 98 펜더입니다. OK66A-52911 L / OK66A-52921 R 규격으로 제작되었습니다.',
    compatibleVehicles: ['K3000', '프론티어', '봉고 98'],
    voltage: '-',
    partNumber: 'OK66A-52911 L / OK66A-52921 R',
    image: 'https://readdy.ai/api/search-image?query=Kia%20K3000%20Frontier%20Bongo%20truck%20fender%20panel%20white%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20lighting&width=800&height=1000&seq=bon052main&orientation=portrait',
    images: [],
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-shield-check-line', title: '순정 규격', description: 'OK66A-52911 L / OK66A-52921 R' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
      { icon: 'ri-star-line', title: '고품질', description: '내구성 보장' },
      { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '안심 사용' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20fender%20manufacturing%20clean%20facility%20professional%20lighting&width=1200&height=900&seq=bon052craft&orientation=landscape',
      story: 'K3000 프론티어 봉고 98의 측면을 보호하는 펜더입니다.',
      details: ['순정 규격 제작', '고품질 소재', '내구성 보장', '완벽한 호환'],
    },
  },
  {
    id: 1106,
    name: 'BON053',
    category: 'KIA K3000 FRONTIER BONGO98',
    subcategory: '외장',
    price: 0,
    status: '재고있음',
    description: 'HOOD',
    fullDescription: 'K3000 프론티어 봉고 98 후드입니다. OK60A-70-810A / OK6BD-52310 규격으로 제작되었습니다.',
    compatibleVehicles: ['K3000', '프론티어', '봉고 98'],
    voltage: '-',
    partNumber: 'OK60A-70-810A / OK6BD-52310',
    image: 'https://readdy.ai/api/search-image?query=Kia%20K3000%20Frontier%20Bongo%20truck%20hood%20panel%20black%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20lighting&width=800&height=1000&seq=bon053main&orientation=portrait',
    images: [],
    colors: ['#000000'],
    features: [
      { icon: 'ri-shield-check-line', title: '순정 규격', description: 'OK60A-70-810A / OK6BD-52310' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
      { icon: 'ri-star-line', title: '고품질', description: '내구성 보장' },
      { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '안심 사용' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20hood%20manufacturing%20clean%20facility%20professional%20lighting&width=1200&height=900&seq=bon053craft&orientation=landscape',
      story: 'K3000 프론티어 봉고 98의 엔진룸을 보호하는 후드입니다.',
      details: ['순정 규격 제작', '고품질 소재', '내구성 보장', '완벽한 호환'],
    },
  },
  {
    id: 1107,
    name: 'BON057',
    category: 'KIA K3000 FRONTIER BONGO98',
    subcategory: '외장',
    price: 0,
    status: '재고있음',
    description: 'BUMPER',
    fullDescription: 'K3000 프론티어 봉고 98 범퍼입니다. OK60E-50031 규격으로 제작되었습니다.',
    compatibleVehicles: ['K3000', '프론티어', '봉고 98'],
    voltage: '-',
    partNumber: 'OK60E-50031',
    image: 'https://readdy.ai/api/search-image?query=Kia%20K3000%20Frontier%20Bongo%20truck%20front%20bumper%20chrome%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20lighting&width=800&height=1000&seq=bon057main&orientation=portrait',
    images: [],
    colors: ['#C0C0C0'],
    features: [
      { icon: 'ri-shield-check-line', title: '순정 규격', description: 'OK60E-50031' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
      { icon: 'ri-star-line', title: '고품질', description: '내구성 보장' },
      { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '안심 사용' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20bumper%20manufacturing%20clean%20facility%20professional%20lighting&width=1200&height=900&seq=bon057craft&orientation=landscape',
      story: 'K3000 프론티어 봉고 98의 전면부를 보호하는 범퍼입니다.',
      details: ['순정 규격 제작', '고품질 소재', '내구성 보장', '완벽한 호환'],
    },
  },
  {
    id: 1108,
    name: 'BON058',
    category: 'KIA K3000 FRONTIER BONGO98',
    subcategory: '외장',
    price: 0,
    status: '재고있음',
    description: 'DOOR SILL SIDE PANEL STEPASSY',
    fullDescription: 'K3000 프론티어 봉고 98 도어실 사이드 패널 스텝어셈블리입니다. OK63B-70340A RH / OK63B-71340A LH / OK60A-70191 RH / OK60A-71191 LH 규격으로 제작되었습니다.',
    compatibleVehicles: ['K3000', '프론티어', '봉고 98'],
    voltage: '-',
    partNumber: 'OK63B-70340A RH / OK63B-71340A LH / OK60A-70191 RH / OK60A-71191 LH',
    image: 'https://readdy.ai/api/search-image?query=Kia%20K3000%20Frontier%20Bongo%20truck%20door%20sill%20side%20panel%20step%20assembly%20on%20clean%20white%20background%20automotive%20spare%20part%20product%20photography%20studio%20lighting&width=800&height=1000&seq=bon058main&orientation=portrait',
    images: [],
    colors: ['#808080'],
    features: [
      { icon: 'ri-shield-check-line', title: '순정 규격', description: 'OK63B-70340A RH / OK63B-71340A LH' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
      { icon: 'ri-star-line', title: '고품질', description: '내구성 보장' },
      { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '안심 사용' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=automotive%20door%20panel%20manufacturing%20clean%20facility%20professional%20lighting&width=1200&height=900&seq=bon058craft&orientation=landscape',
      story: 'K3000 프론티어 봉고 98의 도어 측면을 보호하는 사이드 패널입니다.',
      details: ['순정 규격 제작', '고품질 소재', '내구성 보장', '완벽한 호환'],
    },
  },
];
